import {ACTIVITY_LOG_EXTRACT_DOWNLOAD_RESPONSE} from './action';

const activityLogExtractDownloadReducer = (state = {}, action) => {
    switch (action.type) {
        case ACTIVITY_LOG_EXTRACT_DOWNLOAD_RESPONSE:
            return state = {
                ...state,
                activityLogExtractResponse: action.data
            }
        default: return state
    }
};

export default activityLogExtractDownloadReducer;